module.exports = __webpack_public_path__ + "components/PrintHeader/KrosnoHerb.png?30db976d";


//////////////////
// WEBPACK FOOTER
// ./components/PrintHeader/KrosnoHerb.png
// module id = 2342
// module chunks = 0